module.exports = __webpack_public_path__ + "img/logo-destino-tolima.45e6ee0d.png";